import styles from './campaignReview.module.scss';

const formatMoney = value => {
  const num = Number(value);
  if (!value || Number.isNaN(num)) return null;
  return `$${num.toLocaleString()}`;
};

const Row = ({label, value, missing}) => (
  <div className={styles.row}>
    <span className={styles.label}>{label}</span>
    {value ? (
      <span className={styles.value}>{value}</span>
    ) : (
      <span
        className={missing ? styles['value-missing'] : styles['value-none']}>
        {missing ? 'Not set' : 'None'}
      </span>
    )}
  </div>
);

// Read-only summary of everything that will be submitted, so an admin can
// sanity-check the listing before creating it. `missing` marks a row red
// when a value the campaign really should have is absent.
const CampaignReview = ({campaign, mode}) => {
  const listType = campaign?.listType
    ? campaign.listType.replace(/_/g, ' ')
    : null;
  const founders = campaign?.founders?.length || 0;
  const team = campaign?.teamMembers?.length || 0;
  const docs = campaign?.legalDocuments?.length || 0;

  const sections = [
    {
      title: 'Listing',
      rows: [
        {
          label: 'Type',
          value:
            listType && `${listType} · ${mode === 'TEST' ? 'Test' : 'Live'}`,
          missing: true,
        },
        {label: 'Offering type', value: campaign?.offeringType},
        {label: 'Security type', value: campaign?.securityType},
        {label: 'Language', value: campaign?.language},
      ],
    },
    {
      title: 'Investment terms',
      rows: [
        {
          label: 'Funding target',
          value: formatMoney(campaign?.fundingTarget),
          missing: true,
        },
        {label: 'Valuation', value: formatMoney(campaign?.valuation)},
        {
          label: 'Minimum investment',
          value: formatMoney(campaign?.minimumInvestment),
        },
        {
          label: 'Price per security',
          value: formatMoney(campaign?.pricePerSecurity),
        },
        {
          label: 'daba score',
          value: campaign?.dabaScore ? `${campaign.dabaScore} / 100` : null,
        },
      ],
    },
    {
      title: 'Company',
      rows: [
        {label: 'Stage', value: campaign?.stage},
        {label: 'Location', value: campaign?.location},
        {label: 'Industry', value: campaign?.industry},
        {label: 'Website', value: campaign?.website},
      ],
    },
    {
      title: 'Content',
      rows: [
        {label: 'Founders', value: founders ? `${founders} added` : null},
        {label: 'Team members', value: team ? `${team} added` : null},
        {
          label: 'Legal documents',
          value: docs ? `${docs} uploaded` : null,
        },
      ],
    },
  ];

  return (
    <div className={styles.review}>
      {sections.map(section => (
        <div key={section.title} className={styles.section}>
          <span className={styles['section-title']}>{section.title}</span>
          {section.rows.map(row => (
            <Row
              key={row.label}
              label={row.label}
              value={row.value}
              missing={row.missing}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default CampaignReview;
